export default __webpack_public_path__ + "img/jtc/jtc4_700.webp";